import styles from './renewals-grid.module.scss';
import { useTableConfigHook } from '../../requestUtils';
import { booleanHeader, CreateHeaders, currencyHeader, dateHeader, HeaderSizeEnum, SumRows, TableProductsFilterProps, textHeader } from '@frontend-workspace/react-shared-lib';
import { IRenewals } from '../../_models/renewals';
import { DateRange } from '@mui/x-date-pickers-pro/DateRangePicker';
import { WebkuaTable } from '@frontend-workspace/webkua-lib';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface RenewalsGridProps {
  renewals: IRenewals[],
  onDateChange: (dateRange: DateRange<Date> | null) => void,
  dateRange: DateRange<Date>,
  onRefresh: () => void,
  isLoading: boolean,
  productFilter: TableProductsFilterProps
}

export function RenewalsGrid(props: RenewalsGridProps) {
  const { t } = useTranslation();
  const tableConfig = useTableConfigHook("renewalsReport");

  const headers = CreateHeaders([
    textHeader("companyNumber", t("standard.companyNumber"), HeaderSizeEnum.MEDIUM),
    textHeader("companyName", t("standard.customerName"), HeaderSizeEnum.EXTRA_LARGE),
    textHeader("place", t("standard.place"), HeaderSizeEnum.MEDIUM),
    textHeader("contractResponsible", t("standard.contractManager"), HeaderSizeEnum.EXTRA_LARGE),
    textHeader("sellerName", t("standard.seller"), HeaderSizeEnum.LARGE),
    textHeader("licenseNumber", t("standard.licenseNumber"), HeaderSizeEnum.MEDIUM),
    textHeader("type", t("standard.type"), HeaderSizeEnum.MEDIUM),
    textHeader("interval", t("standard.period"), HeaderSizeEnum.SMALL, {
      cellStyle: { justifyContent: 'right' },
      headerClass: "ag-right-aligned-header"
    }),
    textHeader("seats", t("standard.seats"), HeaderSizeEnum.SMALL, {
      cellStyle: { justifyContent: 'right' },
      headerClass: "ag-right-aligned-header",
      summary: SumRows
    }),
    textHeader("recurringVismaId", t("standard.recurringItem"), HeaderSizeEnum.EXTRA_LARGE),
    textHeader("productName", t("standard.productName"), HeaderSizeEnum.EXTRA_LARGE),
    textHeader("vismaClient", t("standard.client"), HeaderSizeEnum.EXTRA_LARGE),
    dateHeader("nextInvoiceDate", t("standard.invoiceDate")),
    currencyHeader("invoiceAmount", t("standard.invoiceCost"), HeaderSizeEnum.LARGE, {
      cellStyle: { justifyContent: 'right' },
      headerClass: "ag-right-aligned-header",
      summary: SumRows
    }),
    currencyHeader("recurringCostPrice", t("standard.costPrice"), HeaderSizeEnum.LARGE, {
      cellStyle: { justifyContent: 'right' },
      headerClass: "ag-right-aligned-header",
      summary: SumRows
    }),
    currencyHeader("netGain", t("standard.netGain"), HeaderSizeEnum.LARGE, {
      cellStyle: { justifyContent: 'right' },
      headerClass: "ag-right-aligned-header",
      summary: SumRows
    }),
    textHeader("nimbusCode", t("standard.code"), HeaderSizeEnum.SMALL),
    textHeader("productGroup", t("standard.productGroup"), HeaderSizeEnum.LARGE),
    dateHeader("terminatonDate", t("standard.expiryDate")),
    textHeader("timesInvoicedInPeriod", t("renewalsGrid.timesInvoicedInPeriod"), HeaderSizeEnum.SMALL, {
      cellStyle: { justifyContent: 'right' },
      headerClass: "ag-right-aligned-header"
    }),
    booleanHeader("isActiveNextInvoice", t("renewalsGrid.activeNextInvoice")),
    booleanHeader("isActive", t("standard.active"))
  ]);

  return (
    <WebkuaTable
      isLoading={props.isLoading}
      onRefresh={props.onRefresh}
      headers={headers}
      tableConfig={tableConfig}
      productsFilter={props.productFilter}
      data={props.renewals}
      pageSize={15}
      dateRange={props.dateRange}
      onSetDateRange={props.onDateChange}
    />
  );
}

export default RenewalsGrid;